import { NavLink, Outlet } from 'react-router';
import { cn } from '@/lib/utils';
import { SETTINGS_SECTIONS } from './nav';

/** Tabs of the settings area (/impostazioni/*). */
export function SettingsLayout() {
  return (
    <div>
      <nav
        aria-label="Sezioni impostazioni"
        className="mb-6 flex gap-1 overflow-x-auto rounded-lg bg-muted p-1"
      >
        {SETTINGS_SECTIONS.map((s) => (
          <NavLink
            key={s.key}
            to={s.to}
            className={({ isActive }) =>
              cn(
                'inline-flex h-11 shrink-0 items-center rounded-md px-4 text-sm font-medium text-muted-foreground',
                isActive && 'bg-background text-foreground shadow-sm',
              )
            }
          >
            {s.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
